module.exports = __webpack_public_path__ + "static/img/5.118ca34.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/star/jydbv20230320/5.png
// module id = 5987
// module chunks = 0